var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact"},[_c('h1',[_vm._v("\n    "+_vm._s(_vm.greeting)+"\n    "),_c('br'),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"mailto:BrockMRohloff@gmail.com"}},[_vm._v(_vm._s(_vm.tagline))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37896762","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contact.vue
// module id = null
// module chunks = 